import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import store from 'Redux/store';

export default function TrackingLink({ to, children, setMegaMenuTab, ...props }) {
  const onClick = () => {
    store.dispatch({
      type: 'frontend/click/CLICK_INTERACTION',
      payload: { section: 'CategoriesMegaMenu', value: to },
    });
    setMegaMenuTab('');
  };

  return (
    <Link to={to} role="menuitem" onClick={onClick} {...props}>
      {children}
    </Link>
  );
}

TrackingLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  setMegaMenuTab: PropTypes.func,
};

TrackingLink.defaultProps = {
  setMegaMenuTab: () => {},
};
